<div class="flex-column" style="max-width: 1300px;">
    <img src="./assets/images/roshd-p1.jpg">
    <div style="position: relative;">
        <img src="./assets/images/roshd-p2.jpg">
        <a class="btn l-btn" target="_blank" href="https://online.aban.net/Login"></a>
        <a class="btn r-btn" target="_blank" href="https://ehraz.aban.net/"></a>
    </div>


    <img  src="./assets/images/roshd-p3.jpg">
    <div style="position: relative;">
        <img src="./assets/images/roshd-p4.jpg">
        <a class="btn r-btn" target="_blank" href="https://ehraz.aban.net/"></a>
    </div>

    <img  src="./assets/images/roshd-p5.jpg">
    <div style="position: relative;">
        <img src="./assets/images/roshd-p6.jpg">
        <a class="btn r-btn" target="_blank" href="/training/etf"></a>
    </div>
    <img  src="./assets/images/roshd-p7.jpg">
    <div style="position: relative;">
        <img src="./assets/images/roshd-p8.jpg">
        <a class="btn r-btn" target="_blank" href="/training/online-plus"></a>
    </div>
    <div style="position: relative;">
        <img src="./assets/images/roshd-p9.jpg">
        <a class="btn r-btn" target="_blank" href="https://rpfund.ir/"></a>
        <a class="btn l-btn" target="_blank" href="tel:+982185510"></a>
    </div>

    <!-- <div style="border: 3px solid #eee ;border-radius:10px; padding: 20px;">
        <h4>اطلاعات تکمیلی</h4>
        <h5 style="text-align: right;">صندوق‌های قابل معامله چیست</h5>
        <p>واحد صندوق‌های قابل معامله (ETF) در بازار سرمایه داد و ستد می‌شود و قیمت آن‌ها از طریق مکانیزم عرضه و تقاضا،
            با قیمتی نزدیک به NAV تعیین می‌گردد.</p>
        <p style="text-align: right;"><a class="wpfs button primary round " style="color: #fff;" target="_blank"
                href="https://rpfund.ir/" rel="noopener">آشنایی با صندوق‌های ETF</a></p>
        <p>&nbsp;<br></p>
        <h5 style="text-align: right;">معاملات برخط چیست</h5>
        <p>با استفاده از کامپیوتر و یا تلفن همراه با اتصال به به سامانه معاملات برخط ، خرید و فروش در بورس اوراق بهادار تهران، بدون واسطه و در ساعات معاملات 
            امکان‌پذیر می‌باشد.
        </p>
        <p style="text-align: right;"><a class="wpfs button primary round " style="color: #fff;" target="_blank"
                href="https://rpfund.ir/" rel="noopener">آشنایی با معاملات برخط</a></p>
        <p>&nbsp;<br></p>
    </div>

    <p style="padding: 20px;">جهت کسب اطلاعات بیشتر می‌توانید به سامانه صندوق رشد پایدار به نشانی
        <a href="https://rpfund.ir/">www.rpfund.ir</a>
        مراجعه نمایید و یا از طریق شماره
        <a href="tel:+982185510">۸۵۵۱۰ - ۰۲۱</a>
        با واحد امور مشتریان تماس بگیرید
    </p> -->
</div>